import Link from "@mui/material/Link";
import { useDispatch } from "react-redux";
import { push } from "redux-first-history";

export default function SpringboroPolicy() {
  const dispatch = useDispatch();
  const revision = "1-11-24"; // Date Springboro sent us source document. See parent git repo's documentation for source files
  return (
    <>
      <h3 data-revision={revision}>Introduction </h3>

      <p>
        Local Income-Tax Made Easy “LIME” is software designed to allow you to
        prepare and file your local tax return. It is provided by the City of
        Springboro (“City”) to its resident tax payers. If you access or use
        LIME, it means you agree to be bound by the terms of this Privacy Policy
        and{" "}
        <Link
          component="button"
          sx={{ fontSize: "1em" }}
          onClick={() => dispatch(push("/policies/terms"))}
        >
          Terms of Use
        </Link>
        .
      </p>

      <p>
        This Privacy Policy outlines how we collect, use, and protect your
        personal information in conjunction with LIME, including any
        interactions with third parties.
      </p>

      <h3>Collection of Information:</h3>
      <p>
        We will collect no personal information about you when you visit our
        website unless you choose to provide that information to us voluntarily.
      </p>

      <p>
        Our web server automatically collects limited passive information about
        your computer configuration when you visit our web site, including the
        type of browser you use, the operating system you are running, the
        resolution of your computer monitor, the web site that referred you, and
        your IP address. Your IP address is a number that is used by computers
        connected to the Internet to identify your computer so that data such as
        the web pages you want to view can be transmitted to you. We use IP
        address information for systems administration and trouble-shooting
        purposes.
      </p>

      <h3>Cookies:</h3>
      <p>
        To help make our web site more responsive to the needs of our visitors,
        we use a standard feature of browser software, called a “cookie” to
        assign each visitor a unique, random number that resides on your
        computer. The cookie does not identify the visitor, just the computer
        that a visitor uses to access our site. Unless you voluntarily identify
        yourself, we won't know who you are, even if we assign a cookie to your
        computer as the only personal information a cookie can contain is
        information you supply. A cookie cannot read unrelated data off your
        computer. If you wish to block, erase, or be warned of cookies on the
        site, please refer to your browser manufacturer to learn about these
        functions. However, if you choose to remove or reject cookies, this
        could affect certain features on the site.
      </p>

      <h3>Personal Information:</h3>
      <ul>
        In order to provide the tax preparation services associated with LIME we
        may collect the following personal information:
        <li>Name</li>
        <li>Address</li>
        <li>Email/phone number</li>
        <li>Social Security Number</li>
        <li>
          Tax-related data (including but not limited to spouse, dependent,
          income, deductions)
        </li>
        <li>Financial Statements</li>
        <li>Employer Information</li>
        <li>Contact information</li>
        <li>
          Other information required for tax processing including any forms,
          files, or other data that you may choose to upload or import to use
          LIME
        </li>
        <li>
          Through third parties, we or they may collect credit card account,
          card, or payment information if you pay using a credit card.
        </li>
      </ul>

      <p>
        We may use your personal and financial information we collect through
        our site for the purpose of helping you prepare and file your local tax
        return. We may also use the information collected for troubleshooting
        purposes. For example, we may use personal and other information we
        collect to request feedback, communicate with you, respond to user
        inquiries or issues, monitor site usage trends, prevent fraud and for
        any other purpose for which the information was collected.
      </p>

      <p>
        We do not sell any personal information to third parties. We do share
        and transfer certain personal information to third parties in
        conjunction with the LIME software in order to process your tax return.
      </p>

      <p>
        LIME will use tax return information you provide us in order to assist
        you in preparing and filing your local tax return. The use and
        disclosure of this information may be governed by Section 7216 of the
        Internal Revenue Code and Ohio law. We will only use your tax return
        information in accordance with applicable laws in order to assist in the
        preparation and filing of your local tax returns.
      </p>

      <p>
        We may also use certain personal information in order to communicate
        with you if requested through the LIME software. This would include
        providing you with information you’ve requested from us such as
        technical support or filing questions. We will only contact you as
        requested through email or telephone.
      </p>

      <h3>Third Party </h3>
      <p>
        In using LIME, you could be directed to other sites that are beyond our
        control. These other sites may send their own cookies to users, or
        otherwise collect data or solicit personal information. Any personal
        information you provide on linked pages or applications is provided
        directly to that third party and is subject to that third party’s
        privacy policy. This Policy does not apply to such linked sites, and we
        are not responsible for the content or privacy and security practices
        and policies of these websites or any other sites that are linked to or
        from our site.
      </p>

      <p>
        LIME includes a link to a third-party scanning company for document
        submission. We use this scanning software to view and access your W2
        statements containing information to your name, address, social security
        number, employer information, wage and other tax-related information. As
        noted above, this scanning company may have its own privacy policy, and
        we recommend reviewing it separately for information on their data
        handling practices
      </p>

      <p>
        From time to time, we may have advertisements run on our site via third
        party ad servers. These third parties, may use cookies to serve ads
        based on a user's prior visits to the site and other websites. You may
        be able to opt out of personalized advertising by visiting your
        browser’s Ads Settings or utilizing on line third party opt out
        services.
      </p>

      <p>
        We utilize Google Analytics, a web analytics service provided by Google,
        Inc. Google Analytics uses cookies to help analyze how users use sites.
        The information generated by the cookie includes your IP address. This
        information will be transmitted to and stored by Google on its servers.
        Google will use this information for the purpose of evaluating your use
        of the website, compiling reports on website activity, and providing
        other services relating to Internet usage. Google may also transfer this
        information to third parties where required to do so by law, or where
        such third parties process the information on Google’s behalf. By using
        our site, you consent to the processing of data about you by Google in
        the manner and for the purposes set out above. For more information on
        Google Analytics please see the Googles terms of use and Google’s
        privacy practices.
      </p>

      <h3>Other Disclosures:</h3>

      <p>
        We may occasionally release personal and/or passive information about
        our visitors when release is appropriate to comply with law, to protect
        the rights, property or safety of visitors to our sites, the public, our
        customers, or our government and its employees, agents, partners and
        affiliates, or will help to enforce our policies, protect your safety or
        security, including the safety and security of property that belongs to
        you, and/or protect the safety and security of our sites or third
        parties.
      </p>

      <h3>Protecting your Information</h3>

      <p>
        We work to protect your personal information from loss, misuse, or
        unauthorized access, alteration, and destruction by using industry
        standard safeguards, procedures, and practices. Of course, no method of
        transmission over the internet, or method of electronic storage, is
        completely secure. Although we do our best to protect your personal
        information, we cannot guarantee the security of information transmitted
        via LIME.
      </p>

      <h3>Miscellaneous:</h3>

      <p>
        We reserve the right to change, modify, add, or remove portions of this
        Privacy Policy at our discretion. If we decide to change our Privacy
        Policy, we will post those changes here. If you do not agree with the
        terms in this Policy, please do not use this site.{" "}
      </p>

      <p>
        This Privacy Policy is subject exclusively to the laws of the State of
        Ohio in the United States. This site is designed for use by residents of
        the City of Springboro, Ohio. We make no representation that this policy
        and our practices comply with the laws of any other state or country.
        Users of the site who reside outside the United States do so on their
        own initiative and are responsible for compliance with local laws, if
        and to the extent local laws are applicable. If you reside outside of
        the United States, by using the site, you consent to the transfer,
        processing and use of your information outside your country.
      </p>

      <p>
        If you have questions please contact the City of Springboro tax
        department at 877-957-LIME.
      </p>
    </>
  );
}
